import React from 'react';

function Answer(props) {
  let answerExtraClass = props.isSelected 
    ? (props.answer.isCorrect ? 'correct' : 'incorrect')
    : '';
  return (
    <div className="answer">
      <button 
        type="button" 
        className={`btn btn-answer ${answerExtraClass}`} 
        onClick={() => props.onClick(props.option, props.answer.isCorrect)}
        disabled={props.disabled}
      >
        {props.isSelected && <span className="bullet-time">{`${props.time}s`}</span>}
        {props.answer.answer}
      </button>
    </div>
  );
}

export default Answer;